"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

/**
 * CalendarEventV2 Icon Component
 *
 * Tree-shakeable icon component for calendar events.
 *
 * @example
 * ```tsx
 * import CalendarEventV2 from '@insided/destination/icons/CalendarEventV2'
 *
 * <CalendarEventV2 width={20} height={20} fill="#333" />
 * ```
 */
var CalendarEventV2 = function CalendarEventV2(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Calendar event",
    focusable: "false"
  }, props), (0, _preact.h)("g", {
    clipPath: "url(#clip0_155_46)"
  }, (0, _preact.h)("path", {
    d: "M14.4058 18C13.7353 18 13.1667 17.7686 12.7 17.3057C12.2333 16.8427 12 16.2761 12 15.6057C12 14.9352 12.2314 14.3667 12.6943 13.9C13.1573 13.4333 13.7239 13.2 14.3943 13.2C15.0648 13.2 15.6333 13.4314 16.1 13.8942C16.5667 14.3572 16.8 14.9239 16.8 15.5942C16.8 16.2647 16.5686 16.8333 16.1058 17.3C15.6428 17.7667 15.0761 18 14.4058 18ZM5.4 21.6C4.905 21.6 4.48125 21.4208 4.12875 21.0625C3.77625 20.7042 3.6 20.2833 3.6 19.8V6.59999C3.6 6.11666 3.77625 5.69583 4.12875 5.33749C4.48125 4.97916 4.905 4.79999 5.4 4.79999H7.2V2.39999H9V4.79999H15V2.39999H16.8V4.79999H18.6C19.095 4.79999 19.5188 4.97916 19.8713 5.33749C20.2238 5.69583 20.4 6.11666 20.4 6.59999V19.8C20.4 20.2833 20.2238 20.7042 19.8713 21.0625C19.5188 21.4208 19.095 21.6 18.6 21.6H5.4ZM5.4 19.8H18.6V10.8H5.4V19.8ZM5.4 8.99999H18.6V6.59999H5.4V8.99999Z",
    fill: "currentColor"
  })), (0, _preact.h)("defs", null, (0, _preact.h)("clipPath", {
    id: "clip0_155_46"
  }, (0, _preact.h)("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};

var _default = CalendarEventV2;
exports.default = _default;